<template>
<div id="tools">
  <div class="container-fluid">
    <div class="main">
      <div class="tools-content">
        <router-view></router-view>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'tools'
}
</script>

<style scoped lang="less">
@import '~variables';
.main {
    padding-bottom: 3rem;
}

.tools-content {
  width: 100%;
  display: inline-block;
}
</style>
